var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "portal-designer" },
    [
      Object.keys(_vm.errorSnackbarData).length > 0
        ? _c(
            "v-alert",
            { staticClass: "mb-2", attrs: { type: "error" } },
            _vm._l(_vm.errorSnackbarData, function (error, key) {
              return _c("div", { key: key }, [
                typeof error === "string"
                  ? _c("span", [_vm._v(_vm._s(error))])
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PortalDesignerOptionsBar", {
        attrs: { saving: _vm.saving },
        on: {
          saveDesign: function ($event) {
            return _vm.saveDesign()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _vm.newdesign
            ? _c(
                "v-card",
                { staticClass: "ma-3", attrs: { flat: "", xs12: "" } },
                [
                  _c(
                    "fieldset",
                    [
                      _c("legend", [_vm._v("Select Page Mode")]),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "pa-0",
                          attrs: { mandatory: true, "hide-details": "" },
                          model: {
                            value: _vm.design.pageMode,
                            callback: function ($$v) {
                              _vm.$set(_vm.design, "pageMode", $$v)
                            },
                            expression: "design.pageMode",
                          },
                        },
                        [
                          _c("v-radio", {
                            staticClass: "ies-green--text",
                            attrs: { label: "List", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            staticClass: "ies-green--text",
                            attrs: { label: "Edit", value: "2" },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            staticClass: "ies-green--text",
                            attrs: { label: "Report", value: "3" },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            staticClass: "ies-green--text",
                            attrs: { label: "Dashboard", value: "4" },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            staticClass: "ies-green--text",
                            attrs: { label: "Data Import", value: "7" },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            staticClass: "ies-green--text",
                            attrs: { label: "Preview", value: "99" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: { id: "editForm" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "ma-3", attrs: { flat: "", xs12: "" } },
                [
                  _c("fieldset", [
                    _c("legend", [_vm._v("Page")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-4" }, [
                      _c("label", { attrs: { for: "displayName" } }, [
                        _vm._v("Page Name"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.pageName,
                            expression: "design.pageName",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: {
                          id: "displayName",
                          type: "text",
                          name: "displayName",
                        },
                        domProps: { value: _vm.design.pageName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "pageName",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "urlPattern" } }, [
                        _vm._v("URL Pattern"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.page_url_pattern,
                            expression: "design.page_url_pattern",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: {
                          id: "urlPattern",
                          type: "text",
                          name: "urlPattern",
                        },
                        domProps: { value: _vm.design.page_url_pattern },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "page_url_pattern",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "ma-3", attrs: { flat: "", xs12: "" } },
                [
                  _c(
                    "fieldset",
                    [
                      _c("legend", [_vm._v("Permissions")]),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "contentType" } }, [
                        _vm._v("Content Type"),
                      ]),
                      _vm._v(" "),
                      _c("v-autocomplete", {
                        attrs: {
                          outlined: "",
                          dense: "",
                          id: "contentType",
                          items: _vm.contentTypeOptions,
                          "item-text": "text",
                          "item-value": "value",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.design.pageContentType,
                          callback: function ($$v) {
                            _vm.$set(_vm.design, "pageContentType", $$v)
                          },
                          expression: "design.pageContentType",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "ma-3", attrs: { flat: "", xs12: "" } },
                [
                  _c("fieldset", [
                    _c("legend", [_vm._v("Related Pages")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "listUrl" } }, [
                        _vm._v("Record List Url"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.listUrl,
                            expression: "design.listUrl",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: { id: "listUrl", type: "text", name: "listUrl" },
                        domProps: { value: _vm.design.listUrl },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.design, "listUrl", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "editUrl" } }, [
                        _vm._v("Record Edit Url"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.editUrl,
                            expression: "design.editUrl",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: { id: "editUrl", type: "text", name: "editUrl" },
                        domProps: { value: _vm.design.editUrl },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.design, "editUrl", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "createUrl" } }, [
                        _vm._v("Record Create Url"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.createUrl,
                            expression: "design.createUrl",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: {
                          id: "createUrl",
                          type: "text",
                          name: "createUrl",
                        },
                        domProps: { value: _vm.design.createUrl },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "createUrl",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "importUrl" } }, [
                        _vm._v("Record Bulk Import Url"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.importUrl,
                            expression: "design.importUrl",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: {
                          id: "importUrl",
                          type: "text",
                          name: "importUrl",
                        },
                        domProps: { value: _vm.design.importUrl },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "importUrl",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "deleteUrl" } }, [
                        _vm._v("Record Delete Url"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.deleteUrl,
                            expression: "design.deleteUrl",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: {
                          id: "deleteUrl",
                          type: "text",
                          name: "deleteUrl",
                        },
                        domProps: { value: _vm.design.deleteUrl },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "deleteUrl",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "parentPage" } }, [
                        _vm._v("Parent Page ID (breadcrumb)"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.parentPage,
                            expression: "design.parentPage",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: {
                          id: "parentPage",
                          type: "text",
                          name: "parentPage",
                        },
                        domProps: { value: _vm.design.parentPage },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "parentPage",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "ma-3", attrs: { flat: "", xs12: "" } },
                [
                  _c("fieldset", [
                    _c("legend", [_vm._v("Introductory Content")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "heading" } }, [
                        _vm._v("Page Heading"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.heading,
                            expression: "design.heading",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: { id: "heading", type: "text", name: "heading" },
                        domProps: { value: _vm.design.heading },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.design, "heading", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "introduction" } }, [
                        _vm._v("Introduction"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.introduction,
                            expression: "design.introduction",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: { id: "introduction", name: "introduction" },
                        domProps: { value: _vm.design.introduction },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "introduction",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "information" } }, [
                        _vm._v("Information"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.information,
                            expression: "design.information",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: { id: "information", name: "information" },
                        domProps: { value: _vm.design.information },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.design,
                              "information",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c("label", { attrs: { for: "warning" } }, [
                        _vm._v("Warning"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.design.warning,
                            expression: "design.warning",
                          },
                        ],
                        staticClass: "full-width text-input-border mt-2 pa-2",
                        attrs: { id: "warning", name: "warning" },
                        domProps: { value: _vm.design.warning },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.design, "warning", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              this.design.pageMode == 1
                ? _c(
                    "v-card",
                    { staticClass: "ma-3 pb-3", attrs: { flat: "", xs12: "" } },
                    [
                      _c(
                        "fieldset",
                        [
                          _c("legend", [_vm._v("Layout")]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("label", [_vm._v("Show Action Buttons")]),
                                  _vm._v(" "),
                                  _c("v-checkbox", {
                                    attrs: { "hide-details": "" },
                                    model: {
                                      value: _vm.design.showActionButtons,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.design,
                                          "showActionButtons",
                                          $$v
                                        )
                                      },
                                      expression: "design.showActionButtons",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "When hidden the page will only list the records; the user will have no buttons to click through to other pages"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("label", [_vm._v("Page Size")]),
                                  _vm._v(" "),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      items: _vm.pageSizes,
                                      "item-text": "text",
                                      "item-value": "value",
                                    },
                                    model: {
                                      value: _vm.design.pageSize,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.design, "pageSize", $$v)
                                      },
                                      expression: "design.pageSize",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.design.pageMode == 7
                ? _c(
                    "v-card",
                    { staticClass: "ma-3 pb-3", attrs: { flat: "", xs12: "" } },
                    [
                      _c(
                        "fieldset",
                        [
                          _c("legend", [_vm._v("Import")]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "pb-3", attrs: { cols: "3" } },
                                [_c("label", [_vm._v("Match on Model Field")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { staticClass: "pb-3", attrs: { cols: "8" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      items: _vm.modelFields,
                                      label:
                                        "The model-field to match imported data on",
                                      "item-text": "optionText",
                                      "item-value": "optionValue",
                                      "single-line": "",
                                    },
                                    model: {
                                      value: _vm.design.importMatchField,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.design,
                                          "importMatchField",
                                          $$v
                                        )
                                      },
                                      expression: "design.importMatchField",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.design.pageMode == 2
                ? _c(
                    "v-card",
                    { staticClass: "ma-3 pb-3", attrs: { flat: "", xs12: "" } },
                    [
                      _c("fieldset", [
                        _c("legend", [_vm._v("Layout")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pb-3" },
                          [
                            _c("label", [_vm._v("Header Column")]),
                            _vm._v(" "),
                            _c(
                              "v-alert",
                              { attrs: { type: "info", value: "true" } },
                              [
                                _vm._v(
                                  "This field can be used for naming pages and titles, and is a more helpful way to remember records than ID numbers.  Choose a field if there is a unique name or reference for each record"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              attrs: {
                                outlined: "",
                                dense: "",
                                items: _vm.headerColumnOptions,
                                "item-text": "text",
                                "item-value": "value",
                              },
                              model: {
                                value: _vm.design.pageHeaderColumn,
                                callback: function ($$v) {
                                  _vm.$set(_vm.design, "pageHeaderColumn", $$v)
                                },
                                expression: "design.pageHeaderColumn",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      this.design.pageMode == 1 || this.design.pageMode == 3
        ? _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c("v-expansion-panel-header", [
                        _c("label", [
                          _vm._v(
                            "Predefined Sorting " +
                              _vm._s(
                                _vm.sortOrdering.length > 0
                                  ? "(" + _vm.sortOrdering.length + ")"
                                  : ""
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        { staticClass: "ies-light-gray" },
                        [
                          _c(
                            "v-card",
                            { staticClass: "pa-3" },
                            [
                              _c(
                                "v-container",
                                [
                                  _c("label", [_vm._v("Sort order")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mt-3 mb-2" }, [
                                    _vm._v(
                                      "The records will be listed in the following order when the page is loaded.  Users will be able to re-order the results for themselves afterwards"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.sortOrdering,
                                    function (sortField, index) {
                                      return _c(
                                        "v-row",
                                        { key: index },
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-autocomplete", {
                                                attrs: {
                                                  outlined: "",
                                                  dense: "",
                                                  items: _vm.modelFields,
                                                  label: "The model-field",
                                                  "item-text": "optionText",
                                                  "item-value": "optionValue",
                                                  "single-line": "",
                                                },
                                                model: {
                                                  value: sortField.modelField,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      sortField,
                                                      "modelField",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "sortField.modelField",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-autocomplete", {
                                                attrs: {
                                                  outlined: "",
                                                  dense: "",
                                                  items: _vm.sortOrderOptions,
                                                  label: "The direction",
                                                  "item-value": "value",
                                                  "single-line": "",
                                                },
                                                model: {
                                                  value: sortField.order,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      sortField,
                                                      "order",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "sortField.order",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ies-coral",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeSorting(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("delete"),
                                                  ]),
                                                  _vm._v(" Remove"),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-green",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addSorting()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("add")]),
                                              _vm._v(" Add Sort Condition"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-coral",
                                              attrs: {
                                                disabled:
                                                  _vm.sortOrdering &&
                                                  _vm.sortOrdering.length == 0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeAllSorting()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("cancel")]),
                                              _vm._v(" Remove All Conditions"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.design.pageMode == 1 || this.design.pageMode == 3
        ? _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c("v-expansion-panel-header", [
                        _c("label", [
                          _vm._v(
                            "Predefined Filters " +
                              _vm._s(
                                _vm.filters &&
                                  _vm.filters.fields &&
                                  _vm.filters.fields.length > 0
                                  ? "(" + _vm.filters.fields.length + ")"
                                  : ""
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        { staticClass: "ies-light-gray" },
                        [
                          _c(
                            "v-card",
                            { staticClass: "pa-3" },
                            [
                              _c(
                                "v-container",
                                [
                                  _c("div", { staticClass: "mt-3 mb-2" }, [
                                    _vm._v("Show me all records where "),
                                    _c("strong", [_vm._v("all")]),
                                    _vm._v(" of these conditions are true:"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.fields,
                                    function (filter, index) {
                                      return _vm.filters && _vm.filters.fields
                                        ? _c(
                                            "v-row",
                                            { key: index },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "4",
                                                  },
                                                },
                                                [
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      items: _vm.modelFields,
                                                      label: "The model-field",
                                                      "item-text": "optionText",
                                                      "item-value":
                                                        "optionValue",
                                                      "single-line": "",
                                                    },
                                                    model: {
                                                      value: filter.modelField,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          filter,
                                                          "modelField",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.modelField",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "2",
                                                  },
                                                },
                                                [
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      items: _vm.operators,
                                                      label: "Operator",
                                                      "item-value": "value",
                                                      "single-line": "",
                                                    },
                                                    model: {
                                                      value: filter.operator,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          filter,
                                                          "operator",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.operator",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "2",
                                                  },
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: filter.value,
                                                        expression:
                                                          "filter.value",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "full-width text-input-border pa-2",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: "Value",
                                                    },
                                                    domProps: {
                                                      value: filter.value,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          filter,
                                                          "value",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "1",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ies-coral",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeFilter(
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("delete"),
                                                      ]),
                                                      _vm._v(" Remove"),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-green",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addFilter()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("add")]),
                                              _vm._v(" Add Filter"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-coral",
                                              attrs: {
                                                disabled:
                                                  _vm.filters.fields.length ==
                                                  0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeAllFilters()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("cancel")]),
                                              _vm._v(" Remove All Filters"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-3" },
        [
          _c(
            "v-expansion-panels",
            [
              _c(
                "v-expansion-panel",
                [
                  _c("v-expansion-panel-header", [
                    _c("label", [
                      _vm._v(
                        "Relationships " +
                          _vm._s(
                            _vm.relationships.length > 0
                              ? "(" + _vm.relationships.length + ")"
                              : ""
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    { staticClass: "ies-light-gray" },
                    [
                      _c(
                        "v-card",
                        { staticClass: "pa-3" },
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "div",
                                { staticClass: "pb-3" },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "primaryModelSelect" } },
                                    [_vm._v("Select the primary model")]
                                  ),
                                  _vm._v(" "),
                                  _c("v-autocomplete", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      id: "primaryModelSelect",
                                      items: _vm.primaryModelOptions,
                                      placeholder: "Select Primary Key Table",
                                      clearable: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.design.primaryModel,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.design,
                                          "primaryModel",
                                          $$v
                                        )
                                      },
                                      expression: "design.primaryModel",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mb-2" }, [
                                _vm._v(
                                  "Show records where the following relationships exist between the relevant models:"
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.relationships,
                                function (relation, index) {
                                  return _c(
                                    "v-row",
                                    { key: index },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", sm: "4" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              items: _vm.modelFieldNames,
                                              label: "Model-field A",
                                              "item-value": "value",
                                              "single-line": "",
                                            },
                                            model: {
                                              value: relation.modelFieldA,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  relation,
                                                  "modelFieldA",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "relation.modelFieldA",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", sm: "2" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              items: _vm.joinTypes,
                                              label: "Join Type",
                                              "item-value": "value",
                                              "single-line": "",
                                            },
                                            model: {
                                              value: relation.joinType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  relation,
                                                  "joinType",
                                                  $$v
                                                )
                                              },
                                              expression: "relation.joinType",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", sm: "4" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              items: _vm.modelFieldNames,
                                              label: "Model-field B",
                                              "item-value": "value",
                                              "single-line": "",
                                            },
                                            model: {
                                              value: relation.modelFieldB,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  relation,
                                                  "modelFieldB",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "relation.modelFieldB",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-coral",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeRelationship(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("delete")]),
                                              _vm._v(" Remove"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ies-green",
                                          on: {
                                            click: function ($event) {
                                              return _vm.addRelationship()
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [_vm._v("add")]),
                                          _vm._v(" Add Relationship"),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ies-coral",
                                          attrs: {
                                            disabled:
                                              _vm.relationships.length == 0,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeAllRelationships()
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [_vm._v("cancel")]),
                                          _vm._v(" Remove All Relationships"),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      this.design.pageMode == 1 || this.design.pageMode == 3
        ? _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c("v-expansion-panel-header", [
                        _c("label", [
                          _vm._v(
                            "Grouping " +
                              _vm._s(
                                _vm.grouping.length > 0
                                  ? "(" + _vm.grouping.length + ")"
                                  : ""
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        { staticClass: "ies-light-gray" },
                        [
                          _c(
                            "v-card",
                            { staticClass: "pa-3" },
                            [
                              _c(
                                "v-container",
                                [
                                  _c("div", { staticClass: "mb-3" }, [
                                    _vm._v(
                                      "Compress the results so that there is one row returned for every unique combination of the following fields, in this order:"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.grouping,
                                    function (groupField, index) {
                                      return _c(
                                        "v-row",
                                        { key: index },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c("v-autocomplete", {
                                                attrs: {
                                                  outlined: "",
                                                  dense: "",
                                                  items: _vm.modelFieldNames,
                                                  label: "Model-field",
                                                  "item-value": "value",
                                                  "single-line": "",
                                                },
                                                model: {
                                                  value: groupField.modelField,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      groupField,
                                                      "modelField",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "groupField.modelField",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ies-coral",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeGrouping(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("delete"),
                                                  ]),
                                                  _vm._v(" Remove"),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-green",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addGrouping()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("add")]),
                                              _vm._v(" Add Grouping Field"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ies-coral",
                                              attrs: {
                                                disabled:
                                                  _vm.grouping.length == 0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeAllGrouping()
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [_vm._v("cancel")]),
                                              _vm._v(" Remove Grouping"),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card",
            { staticClass: "ies-green p-5" },
            [
              _c(
                "v-container",
                {},
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "space-between" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ies-dark-gray--text title ma-3" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(this.getPageMode()) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.design.sections.length == 0 ||
                      _vm.design.pageMode != 3
                        ? _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.addNewSection()
                                    },
                                  },
                                },
                                [_vm._v("Add Section")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "flex-column", attrs: { "no-gutters": "" } },
            _vm._l(_vm.design.sections, function (section, sectionKey) {
              return _vm.design.pageMode == 1 ||
                _vm.design.pageMode == 2 ||
                _vm.design.pageMode == 3 ||
                _vm.design.pageMode == 4 ||
                _vm.design.pageMode == 7
                ? _c(
                    "v-col",
                    { key: sectionKey, staticClass: "col-xs-12" },
                    [
                      _c(
                        "v-expansion-panels",
                        [
                          _c(
                            "v-expansion-panel",
                            { staticClass: "section-panel" },
                            [
                              _c(
                                "v-expansion-panel-header",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "4" } },
                                            [
                                              _c("v-text-field", {
                                                staticStyle: {
                                                  "min-width": "160px",
                                                },
                                                attrs: {
                                                  label: "Section Name",
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "",
                                                },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                  },
                                                },
                                                model: {
                                                  value: section.sectionName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      section,
                                                      "sectionName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "section.sectionName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "auto" } },
                                            [
                                              _c("v-text-field", {
                                                staticStyle: {
                                                  "min-width": "100px",
                                                  "max-width": "120px",
                                                },
                                                attrs: {
                                                  label: "Width",
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "",
                                                  type: "number",
                                                  min: "1",
                                                  max: "12",
                                                  placeholder: "12",
                                                },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                  },
                                                },
                                                model: {
                                                  value: section.sectionWidth,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      section,
                                                      "sectionWidth",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "section.sectionWidth",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "d-flex ml-sm-auto",
                                              attrs: { cols: "auto" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    title: "Move up",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.moveSection(
                                                        "up",
                                                        sectionKey
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("arrow_upward"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    title: "Move down",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.moveSection(
                                                        "down",
                                                        sectionKey
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("arrow_downward"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "ies-coral--text",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    title: "Delete",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.deleteSection(
                                                        sectionKey
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("delete"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-expansion-panel-content",
                                {
                                  class: {
                                    "ies-dark-gray": sectionKey % 2 != 0,
                                    "ies-light-gray": sectionKey % 2 == 0,
                                  },
                                },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "pt-3 pr-3 pl-3" },
                                    [
                                      _c(
                                        "v-container",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { sm: "12" } },
                                                [
                                                  _c(
                                                    "v-expansion-panels",
                                                    [
                                                      _c(
                                                        "v-expansion-panel",
                                                        [
                                                          _c(
                                                            "v-expansion-panel-header",
                                                            [
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Fields"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-expansion-panel-content",
                                                            {
                                                              staticClass:
                                                                "ies-light-gray",
                                                            },
                                                            [
                                                              _c(
                                                                "v-card",
                                                                [
                                                                  _c(
                                                                    "v-container",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex flex-wrap",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "ies-green ma-2",
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.addNewField(
                                                                                    sectionKey,
                                                                                    "modelField"
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Add New Field "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "ma-2",
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.addNewField(
                                                                                    sectionKey,
                                                                                    "customField"
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Add Custom Field "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "ma-2",
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.addNewField(
                                                                                    sectionKey,
                                                                                    "compositeField"
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Add Composite Field "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "ma-2",
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.addNewField(
                                                                                    sectionKey,
                                                                                    "associationField"
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Add Associated Field "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.design
                                                                    .pageMode ==
                                                                    1 ||
                                                                  _vm.design
                                                                    .pageMode ==
                                                                    2 ||
                                                                  _vm.design
                                                                    .pageMode ==
                                                                    3 ||
                                                                  _vm.design
                                                                    .pageMode ==
                                                                    4 ||
                                                                  _vm.design
                                                                    .pageMode ==
                                                                    7
                                                                    ? _c(
                                                                        "PortalDesignerFields",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              section:
                                                                                section,
                                                                              sectionkey:
                                                                                sectionKey,
                                                                              used_models:
                                                                                _vm.usedModels,
                                                                              models:
                                                                                _vm.models,
                                                                              field_display_types:
                                                                                _vm.fieldDisplayTypes,
                                                                              modelFieldNames:
                                                                                _vm.modelFieldNames,
                                                                              joinTypes:
                                                                                _vm.joinTypes,
                                                                              primaryModel:
                                                                                _vm
                                                                                  .design
                                                                                  .primaryModel,
                                                                              design:
                                                                                _vm.design,
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { sm: "12" } },
                                                [
                                                  _c(
                                                    "v-expansion-panels",
                                                    [
                                                      _c(
                                                        "v-expansion-panel",
                                                        [
                                                          _c(
                                                            "v-expansion-panel-header",
                                                            [
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Content"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-expansion-panel-content",
                                                            {
                                                              staticClass:
                                                                "ies-light-gray",
                                                            },
                                                            [
                                                              _c(
                                                                "v-card",
                                                                [
                                                                  _c(
                                                                    "v-container",
                                                                    [
                                                                      _c(
                                                                        "v-row",
                                                                        {
                                                                          staticClass:
                                                                            "mt-2 mb-4",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-container",
                                                                            [
                                                                              _c(
                                                                                "v-row",
                                                                                [
                                                                                  _c(
                                                                                    "v-col",
                                                                                    [
                                                                                      _c(
                                                                                        "label",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              for: "section-introduction",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Introduction"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "input",
                                                                                        {
                                                                                          directives:
                                                                                            [
                                                                                              {
                                                                                                name: "model",
                                                                                                rawName:
                                                                                                  "v-model",
                                                                                                value:
                                                                                                  section.introduction,
                                                                                                expression:
                                                                                                  "section.introduction",
                                                                                              },
                                                                                            ],
                                                                                          staticClass:
                                                                                            "full-width pa-2",
                                                                                          class:
                                                                                            {
                                                                                              "text-input-border-dark":
                                                                                                sectionKey %
                                                                                                  2 ===
                                                                                                0,
                                                                                              "text-input-border":
                                                                                                sectionKey %
                                                                                                  2 !==
                                                                                                0,
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              type: "text",
                                                                                            },
                                                                                          domProps:
                                                                                            {
                                                                                              value:
                                                                                                section.introduction,
                                                                                            },
                                                                                          on: {
                                                                                            input:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                if (
                                                                                                  $event
                                                                                                    .target
                                                                                                    .composing
                                                                                                )
                                                                                                  return
                                                                                                _vm.$set(
                                                                                                  section,
                                                                                                  "introduction",
                                                                                                  $event
                                                                                                    .target
                                                                                                    .value
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-row",
                                                                                [
                                                                                  _c(
                                                                                    "v-col",
                                                                                    [
                                                                                      _c(
                                                                                        "label",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              for: "section-introduction",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Outroduction"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "input",
                                                                                        {
                                                                                          directives:
                                                                                            [
                                                                                              {
                                                                                                name: "model",
                                                                                                rawName:
                                                                                                  "v-model",
                                                                                                value:
                                                                                                  section.outroduction,
                                                                                                expression:
                                                                                                  "section.outroduction",
                                                                                              },
                                                                                            ],
                                                                                          staticClass:
                                                                                            "full-width pa-2",
                                                                                          class:
                                                                                            {
                                                                                              "text-input-border-dark":
                                                                                                sectionKey %
                                                                                                  2 ===
                                                                                                0,
                                                                                              "text-input-border":
                                                                                                sectionKey %
                                                                                                  2 !==
                                                                                                0,
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              type: "text",
                                                                                            },
                                                                                          domProps:
                                                                                            {
                                                                                              value:
                                                                                                section.outroduction,
                                                                                            },
                                                                                          on: {
                                                                                            input:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                if (
                                                                                                  $event
                                                                                                    .target
                                                                                                    .composing
                                                                                                )
                                                                                                  return
                                                                                                _vm.$set(
                                                                                                  section,
                                                                                                  "outroduction",
                                                                                                  $event
                                                                                                    .target
                                                                                                    .value
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { sm: "12" } },
                                                [
                                                  _c(
                                                    "v-expansion-panels",
                                                    [
                                                      _c(
                                                        "v-expansion-panel",
                                                        [
                                                          _c(
                                                            "v-expansion-panel-header",
                                                            [
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Permissions"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-expansion-panel-content",
                                                            {
                                                              staticClass:
                                                                "ies-light-gray",
                                                            },
                                                            [
                                                              _c(
                                                                "v-card",
                                                                [
                                                                  _c(
                                                                    "PortalDesignerPermissions",
                                                                    {
                                                                      attrs: {
                                                                        object:
                                                                          section,
                                                                        permissions:
                                                                          _vm.contentTypeOptions,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { sm: "12" } },
                                                [
                                                  _c(
                                                    "v-expansion-panels",
                                                    [
                                                      _c(
                                                        "v-expansion-panel",
                                                        [
                                                          _c(
                                                            "v-expansion-panel-header",
                                                            [
                                                              _c("label", [
                                                                _vm._v("Rules"),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-expansion-panel-content",
                                                            {
                                                              staticClass:
                                                                "ies-light-gray",
                                                            },
                                                            [
                                                              _c(
                                                                "v-card",
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "ies-green",
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.addNewRule(
                                                                                    sectionKey
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Add New Rule"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "PortalDesignerRules",
                                                                    {
                                                                      attrs: {
                                                                        section:
                                                                          section,
                                                                        sectionkey:
                                                                          sectionKey,
                                                                        models:
                                                                          _vm.models,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { sm: "12" } },
                                                [
                                                  _c(
                                                    "v-expansion-panels",
                                                    [
                                                      _c(
                                                        "v-expansion-panel",
                                                        [
                                                          _c(
                                                            "v-expansion-panel-header",
                                                            [
                                                              _c("label", [
                                                                _vm._v(
                                                                  "Visualisations"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-expansion-panel-content",
                                                            {
                                                              staticClass:
                                                                "ies-light-gray",
                                                            },
                                                            [
                                                              _c(
                                                                "v-card",
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "ies-green",
                                                                          nativeOn:
                                                                            {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  $event.stopPropagation()
                                                                                  return _vm.addNewVisualisation(
                                                                                    sectionKey
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Add New Visualisation"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.design
                                                                    .pageMode ==
                                                                  3
                                                                    ? _c(
                                                                        "div",
                                                                        _vm._l(
                                                                          section.visualisations,
                                                                          function (
                                                                            visualisation,
                                                                            visualisationKey
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                key: visualisationKey,
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "PortalDesignerReportVisualisations",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        section:
                                                                                          section,
                                                                                        sectionkey:
                                                                                          sectionKey,
                                                                                        used_models:
                                                                                          _vm.usedModels,
                                                                                        models:
                                                                                          _vm.models,
                                                                                        field_display_types:
                                                                                          _vm.fieldDisplayTypes,
                                                                                        modelFieldNames:
                                                                                          _vm.modelFieldNames,
                                                                                        joinTypes:
                                                                                          _vm.joinTypes,
                                                                                        primaryModel:
                                                                                          _vm
                                                                                            .design
                                                                                            .primaryModel,
                                                                                        visualisation:
                                                                                          visualisation,
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e()
            }),
            1
          ),
          _vm._v(" "),
          _vm.design.pageMode == 4
            ? _c(
                "div",
                _vm._l(_vm.design.sections, function (section, sectionKey) {
                  return _c(
                    "div",
                    { key: sectionKey },
                    [
                      _c("PortalDesignerDashboard", {
                        attrs: {
                          section: section,
                          sectionkey: sectionKey,
                          used_models: _vm.usedModels,
                          models: _vm.models,
                          field_display_types: _vm.fieldDisplayTypes,
                          modelFieldNames: _vm.modelFieldNames,
                          joinTypes: _vm.joinTypes,
                          primaryModel: _vm.design.primaryModel,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      Object.keys(_vm.errorSnackbarData).length > 0
        ? _c(
            "v-alert",
            { staticClass: "mt-3 mb-2", attrs: { type: "error" } },
            _vm._l(_vm.errorSnackbarData, function (error, key) {
              return _c("div", { key: key }, [
                typeof error === "string"
                  ? _c("span", [_vm._v(_vm._s(error))])
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PortalDesignerOptionsBar", {
        staticClass: "mt-3",
        attrs: { saving: _vm.saving },
        on: {
          saveDesign: function ($event) {
            return _vm.saveDesign()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: parseInt(6000),
            "multi-line": "",
            color: "ies-green",
          },
          model: {
            value: _vm.successSnackbar,
            callback: function ($$v) {
              _vm.successSnackbar = $$v
            },
            expression: "successSnackbar",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "full-height full-width v-align-container text-xs-center",
            },
            [
              _c("h4", { staticClass: "ies-dark-gray--text v-align-div" }, [
                _vm._v("Design Saved"),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: parseInt(6000),
            "multi-line": "",
            color: "ies-coral",
          },
          model: {
            value: _vm.errorSnackbar,
            callback: function ($$v) {
              _vm.errorSnackbar = $$v
            },
            expression: "errorSnackbar",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "full-height full-width v-align-container text-xs-center",
            },
            [
              _c("h4", { staticClass: "ies-dark-gray--text v-align-div" }, [
                _vm._v("Design Not Valid"),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }